import PlanLength from "@/models/Shared/PlanLength";

export default (planLength: PlanLength) => {
    let returnVal = "Undefined";
    switch (planLength) {
        case PlanLength.ThreeMonths:
            returnVal = "3 months";
            break;
        case PlanLength.SixMonths:
            returnVal = "6 months";
            break;
        case PlanLength.TwelveMonths:
            returnVal = "12 months";
            break;
    }
    return returnVal;
}